module.exports = __webpack_public_path__ + "assets/images/premium-features/day-parts-001794.svg";